module.exports = __webpack_public_path__ + "img/concise.84158cd6.svg";